import   React                   ,
       { useEffect               ,
         useState                }  from "react";
import   classNames                 from 'classnames';

import   styles                     from './ReplayStats.module.scss';

import   AnimatedWaitingIcon2       from '../../widget/animations/animatedWaitingIcon2';
import   Box                        from '../../widget/windows/Box';

import   UserInformations2          from '../userManagment/UserInformations2'
		 
import { groupData               ,
         generateStats           ,
         generateChartData       ,
         GroupedData             ,
         ChartData               ,
         initializedGroupedData  ,
         completeGroupData       }  from "../../../dataTypes/dataSetManagment/regroupData";		 
		 
import { Coordinate              }  from '../../../dataTypes/geolocationManagment/types';
import { convertDateToString     ,
         convertStringToDate     ,
         formatDurationInSeconds ,
         timeStepNames           ,
         timeStepTitles          , 
		 roundDate               }  from '../../../dataTypes/timeManagment/utils';

import { UserSession             ,
         ReplaySession           ,
         GetSessionsParams        }  from '../../../dataTypes/customerFrontEventManagment/types';

import { getReplaySessions       ,
  		 computeSessionActivity           ,
         computeSessionActivityEvolution

}  from '../../../dataTypes/customerFrontEventManagment/utils';

import   CustomerFrontEventList     from "./CustomerFrontEventList";

interface ReplayStatsProps {
  userEmail?        : string;
  userId?           : number;
  userCreationDate? : Date;
  height?           : string;
}

export const ReplayStats: React.FC<ReplayStatsProps> = ({ userEmail, userId , userCreationDate, height = "100vh" }) => {

  const now                 = new Date();
  const startOfYesterday    = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0);
  const startOfTomorrow     = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);

  const startOfTwoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1, 0, 0, 0);

  const [ replaySessionList          , setReplaySessionList         ] = useState<ReplaySession[]>([]);
  const [ filteredReplaySessionList  , setFilteredReplaySessionList ] = useState<ReplaySession[]>([]);
  const [ coordinates                , setCoordinates               ] = useState<Coordinate[]>([]);
  
  const [ startDate                  , setStartDate                 ] = useState<Date | null>( (userId || userEmail) ? userCreationDate ?? null : startOfTwoMonthsAgo ?? null );
  const [ endDate                    , setEndDate                   ] = useState<Date | null>(startOfTomorrow);
  const [ filterName                 , setFilterName                ] = useState("");
  const [ timeStep                   , setTimeStep                  ] = useState<string>("1 jour");
  const [ showWaitingIcon            , setShowWaitingIcon           ] = useState(false);
  const [ userToShow                 , setUserToShow                ] = useState<number>(0);

  const [ groupedData       , setGroupedData       ] = useState<GroupedData<ReplaySession>>(initializedGroupedData<ReplaySession>()) 
  const [ chartData         , setChartData         ] = useState<ChartData[]>([])

  const fetchReplaySessions = async (params: GetSessionsParams = {}) => {

    try
     {
      setShowWaitingIcon(true);

      const updatedParams: GetSessionsParams = {
        ...params,
        userEmail,
        userId,
        beginningDate : startDate ?? startOfYesterday,
        endingDate    : endDate   ?? startOfTomorrow
      };

      const sessions = await getReplaySessions(updatedParams);

      setReplaySessionList(sessions);
      setFilteredReplaySessionList(sessions);
     }
    catch (error)
     {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
    finally
     {
      setShowWaitingIcon(false);
   //   setRefreshCount(prev => prev + 1);  // Incrémente le compteur
     }
  };

  const getGroupKey = (timeStep: string) => {

    switch (timeStep)
      {
       case "1 minute"   : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "mm", 1), "yyyy/MM/dd HH:mm")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                              });

       case "5 minutes"  : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(  roundDate (session.startDate, "mm", 5) , "yyyy/MM/dd HH:mm")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                              });

       case "10 minutes" : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString( roundDate (session.startDate, "mm", 10) , "yyyy/MM/dd HH:mm")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH:mm"), "dd/MM/yyyy HH:mm")}`
                                                              });

       case "1 heure"    : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "HH", 1), "yyyy/MM/dd HH")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                              });

       case "6 heures"   : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "HH", 6), "yyyy/MM/dd HH")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                            });

       case "12 heures"  : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "HH", 12), "yyyy/MM/dd HH")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd HH"), "dd/MM/yyyy HH")}:00`,
                                                              });

       case "1 jour"     : return (session: ReplaySession) => ({
                                                               key      : `${convertDateToString(roundDate (session.startDate, "dd", 1), "yyyy/MM/dd")}`,
                                                               renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                              });

       case "1 semaine"  : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "dd", 7), "yyyy/MM/dd")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                              });

       case "2 semaines" : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "HH", 14), "yyyy/MM/dd")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM/dd"), "dd/MM/yyyy")}`,
                                                              });

       case "1 mois"     : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "MM", 1), "yyyy/MM")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                              });

       case "6 mois"     : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "MM", 6), "yyyy/MM")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy/MM"), "MM/yyyy")}`,
                                                              });

       case "1 an"       : return (session: ReplaySession) => ({
                                                                 key      : `${convertDateToString(roundDate (session.startDate, "yyyy", 1), "yyyy")}`,
                                                                 renderer : (val: string) => `${convertDateToString(convertStringToDate(val,"yyyy"), "yyyy")}`,
                                                              });

       default           : throw new Error(`Unsupported timeStep: ${timeStep}`);
      }
  };

  const getRenderer = (val: Date): string => {

    switch (timeStep)
      {
       case "1 minute"   : return `${convertDateToString(val, "HH:mm",'')}`
       case "5 minutes"  : return `${convertDateToString(val, "HH:mm",'')}`
       case "10 minutes" : return `${convertDateToString(val, "HH:mm",'')}`
       case "1 heure"    : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "6 heures"   : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "12 heures"  : return `${convertDateToString(val, "dd/MM/yyyy HH",'')}:00`
       case "1 jour"     : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 semaine"  : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "2 semaines" : return `${convertDateToString(val, "dd/MM/yyyy",'')}`
       case "1 mois"     : return `${convertDateToString(val, "MM/yyyy",'')}`
       case "6 mois"     : return `${convertDateToString(val, "MM/yyyy",'')}`
       case "1 an"       : return `${convertDateToString(val, "yyyy",'')}`
       default           : throw new Error(`Unsupported timeStep: ${timeStep}`)
      }
  };

  useEffect(() => {
    fetchReplaySessions();
  }, [userEmail, userId, startDate, endDate]);

  useEffect(() => {

    const coords = filteredReplaySessionList.map(session => ({
        lat   :    session.ipAddressLat  || 0,
        lng   :    session.ipAddressLon  || 0,
        info1 :    convertDateToString (session.startDate, 'dd/MM/yyyy HH:mm:ss' ), // session.ipAddress     || "N/A",
        info2 : `${session.userFirstname || "N/A"} ${session.userLastname || "N/A"}`,
		color : 'violet'
      }));

    setCoordinates(coords);

    const groupedDataTemp    = groupData<ReplaySession> (filteredReplaySessionList, getGroupKey(timeStep));
    const completedGroupData =
       startDate && endDate
       ? completeGroupData<ReplaySession>(groupedDataTemp, timeStep, startDate, endDate)
       : completeGroupData<ReplaySession>(groupedDataTemp, timeStep);
  
    const statsResult   = generateStats<ReplaySession> ( completedGroupData , () => 1 , (a, b) => a + b );
    const chartDataTemp = generateChartData<ReplaySession> ( statsResult, completedGroupData);

    console.log ( "filteredReplaySessionList : " , filteredReplaySessionList )
    console.log ( "getGroupKey               : " , getGroupKey(timeStep)   )
    console.log ( "groupedDataTemp           : " , groupedDataTemp         )
    console.log ( "completedGroupData        : " , completedGroupData      )
    console.log ( "statsResult               : " , statsResult             )
    console.log ( "chartDataTemp             : " , chartDataTemp           )

    const now               = new Date ();
    const currentMonthStart = new Date (now.getFullYear(), now.getMonth(), 1, 0, 0, 0);

    let audiencePeriodStartDate = startDate ?? currentMonthStart
    let audiencePeriodEndDate   = endDate   ?? now

    const temp = computeSessionActivityEvolution ( computeSessionActivity ( filteredReplaySessionList  as UserSession[] ) ,
                                                                            timeStep          ,
		                                                                    audiencePeriodStartDate      ,
							                                                audiencePeriodEndDate        )

    const chart = temp.map ( d => {

      return {
        group: getRenderer ( d.date ),
        series: [ { name: 'data', value: d.activity } ]
      };
    });

    setGroupedData ( completedGroupData )
    setChartData (chart) // (chartDataTemp)

  }, [filteredReplaySessionList]);

  useEffect(() => {
	  
    const groupedDataTemp    = groupData<ReplaySession> (filteredReplaySessionList, getGroupKey(timeStep));
    const completedGroupData =
       startDate && endDate
       ? completeGroupData<ReplaySession>(groupedDataTemp, timeStep, startDate, endDate)
       : completeGroupData<ReplaySession>(groupedDataTemp, timeStep);
  
    const statsResult   = generateStats<ReplaySession> ( completedGroupData , () => 1 , (a, b) => a + b );
    const chartDataTemp = generateChartData<ReplaySession> ( statsResult, completedGroupData);

    setGroupedData ( completedGroupData )
    setChartData (chartDataTemp)

    console.log (timeStep, groupedDataTemp,completedGroupData,chartDataTemp)

  }, [timeStep]);
  
  const handleSpanClick = (userId:number) => {
	  
    console.log(`Affiche infos du user ${userId}`); // Add semicolon here

    setUserToShow (userId)
  }
  
  const handleClose = () => {
	  
    setUserToShow (0)
  }

  const handleDateRangeChange = (start: string, end: string) => {

    const date1 = convertStringToDate (start,'dd/MM/yyyy HH:mm');
    const date2 = convertStringToDate (end  ,'dd/MM/yyyy HH:mm');

    setStartDate (date1);
    setEndDate   (date2);
  };

  const handleTimeStepChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    setTimeStep(e.target.value);
  };

  const filterReplaySession = ( filterName: string): ReplaySession[] => {
	  
    let filteredSessionList = replaySessionList;

    if (filterName !== "") 
	 {
      const filterTextLowerCase = filterName.toLowerCase();

      filteredSessionList = replaySessionList.filter(
        (replaySession) =>
          replaySession.userId.toString().toLowerCase().includes(filterTextLowerCase) ||
          replaySession.userEmail.toLowerCase().includes(filterTextLowerCase) ||
          replaySession.userFirstname.toLowerCase().includes(filterTextLowerCase) ||
          replaySession.userLastname.toLowerCase().includes(filterTextLowerCase) 
      );
    }

    return filteredSessionList;
  };

  const handleFilterNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
	  
    const newFilterName = e.target.value;
    setFilterName (newFilterName);
    setFilteredReplaySessionList (filterReplaySession(newFilterName));
  };

  const handleRefresh = () => {
    fetchReplaySessions({ beginningDate: startDate || undefined, endingDate: endDate || undefined });
  };

  let columns = [
    { header: "Date"            , accessor: "startDate"             as keyof ReplaySession , width: '120px', cellRenderer: (value: any) => ( <span>{convertDateToString(value as Date,'dd/MM/yyyy HH:mm:ss') }</span> ) },
    { header: "Durée"           , accessor: "duration"              as keyof ReplaySession , width: '85px', cellRenderer: (value: any) => ( <span>{formatDurationInSeconds(value as number) }</span> )                 },
    { header: "Nom de la vidéo" , accessor: "videoTitle"            as keyof ReplaySession , width: '350px'},
    { header: "UserId"          , accessor: "userId"                as keyof ReplaySession , width: '80px', cellRenderer: (value: any) => (<span onClick={() => handleSpanClick(value)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{value}</span>) },
  //  { header: "Prénom"          , accessor: "userFirstname"         as keyof ReplaySession , width: '150px' },
  //  { header: "Nom"             , accessor: "userLastname"          as keyof ReplaySession , width: '150px' },
    { header: "Email"           , accessor: "userEmail"             as keyof ReplaySession , width: '250px'},
    { header: "Address IP"      , accessor: "ipAddress"             as keyof ReplaySession , width: '140px' },
    { header: "FAI"             , accessor: "ipAddressProviderName" as keyof ReplaySession , width: '200px'},
    { header: "Ville"           , accessor: "ipAddressCity"         as keyof ReplaySession , width: '160px' },
    { header: "Pays"            , accessor: "ipAddressCountry"      as keyof ReplaySession , width: '120px' },
  ];

  if (userId || userEmail)
   {
    columns = [
      { header: "Date"            , accessor: "startDate"             as keyof ReplaySession , width: '160px', cellRenderer: (value: any) => ( <span>{convertDateToString(value as Date,'dd/MM/yyyy HH:mm:ss') }</span> ) },
      { header: "Durée"           , accessor: "duration"              as keyof ReplaySession , width: '70px', cellRenderer: (value: any) => ( <span>{formatDurationInSeconds(value as number) }</span> )                 },
      { header: "Nom de la vidéo" , accessor: "videoTitle"            as keyof ReplaySession , width: '350px'},
      { header: "Address IP"      , accessor: "ipAddress"             as keyof ReplaySession , width: '140px' },
      { header: "FAI"             , accessor: "ipAddressProviderName" as keyof ReplaySession , width: '200px'},
      { header: "Ville"           , accessor: "ipAddressCity"         as keyof ReplaySession , width: '100px' },
      { header: "Pays"            , accessor: "ipAddressCountry"      as keyof ReplaySession , width: '100px' },
    ];
   }

  const generateBarGraphTitle = () : string => {

   return `Nombre de vues en replay`
  }

  const generateBarGraphSubTitle = () : string => {

    const date1 = convertDateToString (startDate ,'dd/MM/yyyy HH:mm')
    const date2 = convertDateToString (endDate   ,'dd/MM/yyyy HH:mm')

    let timeStepTitle : string = ""

    for (let i =0; i<timeStepNames.length ; i++)
     {
      if ( timeStep === timeStepNames [i] )
       {
        timeStepTitle = timeStepTitles [i]
        break;
       }
     }

   return `Du ${date1} au ${date2} ${timeStepTitle}`
  }

  return (

    <div className={classNames(styles.root)}>
      {showWaitingIcon && <AnimatedWaitingIcon2 />}
	  
	  {
	   userToShow !== 0 &&
	   (
  	    <Box width="95vw" height="95vh" onClose={handleClose} logo={true}>
          <UserInformations2 userId={userToShow} />
        </Box>
       )
      }
	  
      <CustomerFrontEventList key                    = { `${timeStep}`                                     }
                              startDate              = { convertDateToString(startDate,'dd/MM/yyyy HH:mm') }
                              endDate                = { convertDateToString(endDate,'dd/MM/yyyy HH:mm')   }
                              filterName             = { filterName                                        }
                              timeStep               = { timeStep                                          }
                              sessions               = { filteredReplaySessionList                         }
                              coords                 = { coordinates                                       }
                              columns                = { columns                                           }
                              handleRefresh          = { handleRefresh                                     }
                              handleDateRangeChange  = { handleDateRangeChange                             }
                              handleFilterNameChange = { handleFilterNameChange                            }
                              handleTimeStepChange   = { handleTimeStepChange                              }
                              groupedData            = { groupedData                                       }
                              chartData              = { chartData                                         }
                              barGraphTitle          = { generateBarGraphTitle()                           }
                              barGraphSubTitle       = { generateBarGraphSubTitle()                        }
                              height                 = { height                                            }
                              ready                  = { !showWaitingIcon                                  }
                              renderRowDetails       = { rowData => (
                                                                    <table className={styles.subTable}>
                                                                      <thead>
                                                                        <tr>
                                                                          <th>Evénements</th>
                                                                          <th>Timecode de début</th>
                                                                          <th>Timecode de fin</th>
                                                                          <th>Durée</th>
                                                                        </tr>
                                                                      </thead>
                                                                      <tbody>
                                                                        {
                                                                         rowData.watchedSegments.map ((segment, index) => (
                                                                           <tr key={index}>
                                                                             <td>{                          segment.event      }</td>
                                                                             <td>{ formatDurationInSeconds (segment.startTime) }</td>
                                                                             <td>{ formatDurationInSeconds (segment.endTime  ) }</td>
                                                                             <td>{ formatDurationInSeconds (segment.duration ) }</td>
                                                                           </tr>
                                                                          ))
                                                                        }
                                                                      </tbody>
                                                                    </table>
                                                                   ) } />

    </div>
  );
};

export default ReplayStats;

                              
